<template>
  <div id="contents">
    <div class="recruit_point" >
      <div class="recruit_point_main">
        <div class="title_area">
          <p class="title">コンテンツ制作の</p>
          <p class="title">強み</p>
        </div>
        <div @click="close" class="back_btn_icon">
          <img src="../assets/img/common/recruit_2021/close.png" alt="close">
        </div>
        <p class="caption">コンテンツ制作を専門に60年以上の実績を誇る当社のストロングポイントをまとめてみました。</p>
        <router-link v-bind:to="{name: 'program_index', params : { link: true }}">
          <div class="more">
            <p class="more_text">詳しい番組実績はこちら</p>
            <p class="more_arrow">▶︎</p>
          </div>
        </router-link>
      </div>
      <div class="recruit_point_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/01.png" alt="01"></p>
        </div>
        <div class="program">
          <p class="title">テレビ朝⽇の番組を制作しています！</p>
          <ul class="list">
            <li><img src="../assets/img/common/recruit_2021/program_logo/good_morning_logo.png" alt="グッド！ モーニング"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/morning_show_logo.png" alt="モーニングショー"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/scramble_logo.png" alt="ワイド！ スクランブル"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/jyun_sanpo_logo.png" alt="じゅん散歩"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/tetuko_no_heya_logo.png" alt="徹子の部屋"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/jinsei_no_rakuen_logo.png" alt="人生の楽園"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/hanataka_logo.png" alt="ハナタカ!優越館"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/sport_ou_logo.png" alt="スポーツ王は俺だ"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/nobunaka_logo.png" alt="ノブナカなんなん？"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/sunday_live_logo.png" alt="サンデー LIVE！！"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/gohan_japan_logo.png" alt="ごはんジャパン"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/syokusai_logo.png" alt="食彩の王国"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/J_channel_logo.png" alt="J チャンネル"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/Qsama_logo.png" alt="Qさま"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/news_reader_logo.png" alt="ニュースリーダー"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/zenryoku_logo.png" alt="全力坂"></li>
          </ul>
        </div>
      </div>
      <div class="recruit_point_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/02.png" alt="02"></p>
        </div>
        <div class="platform">
          <p class="title">テレビ各局からWebまで、幅広いプラットフォーム</p>
          <p class="text">テレビ各局はもちろん、インターネット動画、劇場映画、イベント・ステージ演出など、あらゆるメディアでのコンテンツ制作を手がけています。自分次第でどんなことにも挑戦できる環境です。</p>
          <ul class="list">
            <li>テレビ</li>
            <li>イベント</li>
            <li>Web</li>
            <li>広告</li>
          </ul>
        </div>
      </div>
      <div class="recruit_point_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/03.png" alt="03"></p>
        </div>
        <div class="genre">
          <p class="title">報道からバラエティまでジャンルを問わない番組制作</p>
          <p class="text">報道・情報系番組の生放送から、バラエティ、ドキュメンタリー、ドラマ・映画の企画制作まで、オールジャンルの番組制作実績があります。やりたいことが必ず見つかります。</p>
          <ul class="list">
            <li>バラエティ</li>
            <li>報道</li>
            <li>ドキュ<br />メンタリー</li>
            <div class="center">
              <li>ドラマ</li>
              <li>映画</li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_info',
  data() {
    return {
      info_post: null,
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'info_layout_status',
    'request_tag_id'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  #contents
    width: 100vw
  .recruit_point
    padding-bottom: 77px
    &_main
      width: 90.4vw
      margin: calc(36.1vw - 41px) auto 0
      padding-bottom: 55px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -25px
        left: 21px
      .title
        @include recruit_font(26px, 42px, 0.176em)
        color: #fff
        background: #FFBA00
        padding: 0 12px 0 9px
        display: table
      .caption
        @include recruit_font(12px, 23px, 0.196em)
        margin: calc(23.5vw - 41px) 5.9vw 0
        width: 79.2vw
        height: 52px
        display: inline-block
      a
        color: #000
        text-decoration: none
      .more
        display: flex
        border-bottom: 3px dashed #FF7689
        padding-bottom: 6px
        margin: 32px auto 0
        width: 204px
        &_text
          @include recruit_font(13px, 25px, 0.176em)
        &_arrow
          @include recruit_font(12px, 24px, 0px)
          margin-left: 22px
      .back_btn_icon
        position: absolute
        top: -20.9vw
        left: 0vw
        img
          width: 32px
          height: 32px
    &_list
      width: 90.4vw
      margin: 0 auto
      margin-top: 21px
      background-color: #fff
      position: relative
      .number_area
        position: absolute
        top: 16px
        left: -30px
        display: flex
      .number
        background: #FFBA00
        padding: 8px 10px 0 41px
        img
          width: 42px
          height: 38px
      .program
        padding-top: 62px
        padding-bottom: 30px
        .title
          @include recruit_font(21px, 32px, 0.138em)
          width: 79.2vw
          margin: 17px auto 18px
        .list
          margin: 0 20px 0 20px
          display: flex
          flex-wrap: wrap
          li
            width: 33%
            height: 65px
          img
            width: 105%
      .genre
        padding-top: 62px
        padding-bottom: 35px
        .title
          @include recruit_font(21px, 32px, 0.058em)
          margin: 17px auto 0
          width: 79.2vw
        .text
          @include recruit_font(12px, 23px, 0.182em)
          margin: 19px auto 50px
          width: 79.2vw
          height: 82px
        .list
          margin: 0 auto
          width: 297px
          display: flex
          flex-wrap: wrap
          li
            width: 90px
            height: 90px
            background-color: #FF7689
            @include recruit_font(12px, 17px, 0.131em)
            display: flex
            align-items: center
            justify-content: center
            text-align: center
            border-radius: 65px
            color: #fff
            &:not(:nth-child(3))
              margin-right: 13px
          .center
            display: flex
            margin: 0 auto
            li:first-child
              margin-right: 19px
            li:last-child
              margin-right: 0px

      .platform
        padding-top: 62px
        padding-bottom: 14px
        .title
          @include recruit_font(21px, 32px, 0.008em)
          margin: 17px auto 0
          width: 79.7vw
        .text
          @include recruit_font(12px, 23px, 0.196em)
          margin: 15px auto 27px
          width: 79.2vw
        .list
          margin: 0 auto
          width: 266px
          display: flex
          flex-wrap: wrap
          justify-content: space-between
          li
            width: 120px
            height: 120px
            background-color: #FF7689
            @include recruit_font(16px, 23px, 0.131em)
            display: flex
            align-items: center
            justify-content: center
            text-align: center
            border-radius: 80px
            color: #fff
            margin-bottom: 15px
  @media screen and (max-width: 374px)
    #contents
    .recruit_point
      &_main
        margin: 85px auto 0
        .title_area
          left: 3.8vw
        .title
          @include recruit_font(26px, 42px, 1.5px)
        .caption
        a
        .more
          &_text
          &_arrow
        .back_btn_icon
          top: -78px
          left: 0vw
          img
      &_list
        &:last-child
        .number_area
        .number
          img
        .program
          .title
          .list
            li
            img
        .genre
          .title
          .text
          .list
            width: 90.4vw
            display: flex
            justify-content: center
            li
              width: 24vw
              height: 24vw
              &:not(:nth-child(3))
            .center
              li:first-child
              li:last-child
        .platform
          .title
          .text
          .list
            li
</style>



// WEBPACK FOOTER //
// src/components/recruit_point.vue